import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {FormsModule} from '@angular/forms';

import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'app-controls-section',
    templateUrl: './controls-section.component.html',
    styleUrls: ['./controls-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class ControlsSectionComponent implements OnChanges {

  readonly selections = input.required<GuruEntity[]>();
  readonly invalidEntityNames = input.required<string[]>();
  readonly handArrangementImagePath = input<string>(undefined!);
  readonly pipeDetailImagePath = input<string>(undefined!);
  readonly selectionChanged = output<GuruEntity>();
  controlVoltageSelection!: GuruEntity;
  thermostatTypeSelection!: GuruEntity;
  thermostatLocationSelection!: GuruEntity;
  controlDoorSelection!: GuruEntity;
  doorCamlocksSelection!: GuruEntity;
  serviceSwitchSelection!: GuruEntity;
  skyportServiceSelection!: GuruEntity;
  condensateSwitchSelection!: GuruEntity;
  terminalStripSelection!: GuruEntity;
  collapsed: boolean = false;
  canExpand: boolean = true;
  private readonly selectionNames: string[] = ['USControlVoltage', 'USThermostat', 'USTstatMountLocation', 'USAccessDoorOption', 'USDoorCam', 'USServSw', 'USSkyportSetupService', 'USCondensateSwitch', 'USTermStrip'];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filteredSelections: GuruEntity[] = this.selections().filter(selection => this.selectionNames.indexOf(selection.Name) >= 0);
    if (filteredSelections.length === 0) {
      this.collapsed = true;
      this.canExpand = false;
    } else {
      this.controlVoltageSelection = this.getSelectionWithName(this.selectionNames[0], filteredSelections);
      this.thermostatTypeSelection = this.getSelectionWithName(this.selectionNames[1], filteredSelections);
      this.thermostatLocationSelection = this.getSelectionWithName(this.selectionNames[2], filteredSelections);
      this.controlDoorSelection = this.getSelectionWithName(this.selectionNames[3], filteredSelections);
      this.doorCamlocksSelection = this.getSelectionWithName(this.selectionNames[4], filteredSelections);
      this.serviceSwitchSelection = this.getSelectionWithName(this.selectionNames[5], filteredSelections);
      this.skyportServiceSelection = this.getSelectionWithName(this.selectionNames[6], filteredSelections);
      this.condensateSwitchSelection = this.getSelectionWithName(this.selectionNames[7], filteredSelections);
      this.terminalStripSelection = this.getSelectionWithName(this.selectionNames[8], filteredSelections);
    }
  }

  private getSelectionWithName(name: string, selections: GuruEntity[]): GuruEntity {
    for (const selection of selections) {
      if (selection.Name === name) {
        return JSON.parse(JSON.stringify(selection));
      }
    }
    return undefined!;
  }

  selectedValueChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChanged.emit(entity);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  isInvalidSelection(selectionName: string): boolean {
    return this.invalidEntityNames().indexOf(selectionName) >= 0;
  }

}
